/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";

type ChromeMem = {
	jsHeapSizeLimit: number
	totalJSHeapSize: number
	usedJSHeapSize: number
}

export class MemoryMonitor
	extends React.Component<any, any> {
	private id!: any;

	componentDidMount() {
		this.id = setInterval(() => {
			this.forceUpdate();
		}, 1000);
	}

	componentWillUnmount() {
		clearInterval(this.id);
	}

	render() {
		// @ts-ignore
		const mem: ChromeMem = window.performance.memory;
		if(!mem)
			return null;

		return <div id={'memory'}>{Math.round(mem.usedJSHeapSize / 1024 / 1024)} / {Math.round(mem.totalJSHeapSize / 1024 / 1024)}mb</div>;
	}
}